// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7b85acb","498":"8923b042","616":"7c9689bd"}[chunkId] + ".chunk.js";
};